import { configureStore } from "@reduxjs/toolkit";
import grievanceReducer from "../redux/grievance/grievanceSlice";
import categorySubcategoryReducer from "../redux/categorySubcategory/categorySubcategorySlice";
import alumniReducer from "../redux/alumni/alumniSlice";

// Application-wide Redux store for API data.
export const store = configureStore({
  reducer: {
    grievance: grievanceReducer,
    categorySubcategory: categorySubcategoryReducer,
    alumni: alumniReducer,
  },
});
